import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {create_user} from "../services/apiService";
import {useOrganization} from "../context/OrganizationContext";
import {ArrowLeft, UserPlus} from "lucide-react";
import {Card} from "../components/ui/Card";
import {Button} from "../components/ui/Button";
import {Input, Label} from "../components/ui/Input";
import {useToast} from "../components/ui/Toast";

export const AddUserPage = () => {
    const navigate = useNavigate();
    const {selectedOrganizationId} = useOrganization();
    const {showToast} = useToast();

    const [name, setName] = useState("");
    const [surname, setSurname] = useState("");
    const [email, setEmail] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!selectedOrganizationId) {
            showToast("No organization selected.", "error");
            return;
        }

        setSubmitting(true);
        try {
            await create_user(name, surname, email, selectedOrganizationId);
            showToast(`${name} was added to the organization.`, "success");
            navigate("/organization");
        } catch (err) {
            console.error("Error creating user:", err);
            showToast("Failed to create user. Please try again.", "error");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="w-full h-full overflow-y-auto pr-1">
            <div className="flex items-center mb-8 gap-3">
                <button
                    onClick={() => navigate("/organization")}
                    className="size-9 flex items-center justify-center rounded-full text-ink-muted hover:text-primary hover:bg-surface-hover transition-colors"
                >
                    <ArrowLeft size={18}/>
                </button>
                <div>
                    <h1 className="text-2xl font-display font-bold text-ink">Add New User</h1>
                    <p className="text-sm text-ink-muted mt-1">Invite a new teammate to this organization.</p>
                </div>
            </div>

            <Card className="max-w-xl">
                <form onSubmit={handleSubmit} className="space-y-5">
                    <div>
                        <Label>First Name</Label>
                        <Input
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Enter user's first name"
                            required
                        />
                    </div>

                    <div>
                        <Label>Last Name</Label>
                        <Input
                            type="text"
                            value={surname}
                            onChange={(e) => setSurname(e.target.value)}
                            placeholder="Enter user's last name"
                            required
                        />
                    </div>

                    <div>
                        <Label>User Email</Label>
                        <Input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter user's email"
                            required
                        />
                    </div>

                    <div className="pt-2">
                        <Button type="submit" icon={UserPlus} loading={submitting}>
                            Add User
                        </Button>
                    </div>
                </form>
            </Card>
        </div>
    );
};
